import { render, staticRenderFns } from "./AssignWatcherToTheReport.vue?vue&type=template&id=0d82d10c"
import script from "./AssignWatcherToTheReport.vue?vue&type=script&lang=js"
export * from "./AssignWatcherToTheReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports